import {type IAsset, AssetStatus} from '../schema';

export const assetCheckedOut = (asset?: Pick<IAsset, 'status'>) => {
	if (!asset) return false;
	return asset.status === AssetStatus.CHECKOUT;
};
